import React, { useEffect, useState,useRef } from "react";
import { Driver } from "../objects/policy";
import { Button, MenuItem, Select, TextField,FormControl, InputLabel,ToggleButtonGroup,ToggleButton, FormHelperText,AlertColor } from "@mui/material";
import {DatePicker, DateField,LocalizationProvider  } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { addErrorMessage } from "../pages/quoting/Quote";
import DriverService from "../services/driverservice";

export class DriverValidate {
    hasFirstName: boolean = true;
    hasLastName: boolean = true;
    hasDob: boolean = true;
    hasInvalidDob: boolean = true;
    hasMarital: boolean = true;
    hasGender: boolean = true;
    hasLicenseNumber: boolean = true;
    
    firstNameError = "First Name is Required";
    lastNameError = "Last Name is required";
    dobError = "Date Of Birth is required";
    invalidDobError = "Date Of Birth is invalid, please enter a correct date of birth";
    maritalError = "Marital Status is required";
    genderError = "Gender is required";
    licenseNumberError = "License# is required";
}

function EditDriverForm (props: any){
    const {   
        isVisible,
        parent,
        action,
        currentKey, 
        containerKey, 
        drivers,
        driverNumber, 
        policyStae,
        onCloseAction,
        onAddAction,
        onUpdateAction,
    } = props;

    const driverService = new DriverService();

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [suffix, setSuffix] = useState("");
    const [middleInitial, setMiddleInitial] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState<Dayjs | null>();
    const [gender, setGender] = useState("");
    const [licenseNumber, setLicenseNumber] = useState("");
    const [maritalStatus, setMaritalStatus] = useState("");

    const [validationObject, setValidation] = useState<DriverValidate>(new DriverValidate());
    const[errors, setErrors] = useState<string[]>([]);
    const[isToastOpen, setIsToastOpen] = useState(false);
    const[toastSeverity, setToastSeverity] = useState<AlertColor>("success");

    useEffect(()=>{
        
        if (isVisible && action == "EDIT") {    
            var driver = new Driver();
            var foundDriver = driver.get(drivers, driverNumber);

            setFirstName(foundDriver.firstName);
            setLastName(foundDriver.lastName);
            setMiddleInitial(foundDriver.middleInitial);
            setSuffix(foundDriver.suffix);
            setDateOfBirth(dayjs(foundDriver.dob));
            setGender(foundDriver.gender);
            setLicenseNumber(foundDriver.licenseNum);
            setMaritalStatus(foundDriver.isMarried ? "M" : "S");
        }
    }, [isVisible]);
    
    function onSave(e:any){
        var isValid = isFormValid();
       
        if(!isValid) {
            setIsToastOpen(true);
            setToastSeverity("error");
            return;
        }

        switch(action){
            case "EDIT":
   
                onUpdateAction(driverNumber, 
                    firstName,
                    lastName,
                    middleInitial,
                    suffix,
                    dateOfBirth,
                    gender,
                    maritalStatus,
                    licenseNumber);
                break;
            default:
                onAddAction(firstName,
                    lastName,
                    middleInitial,
                    suffix,
                    dateOfBirth,
                    gender,
                    maritalStatus,
                    licenseNumber);
                break;
        }

        onCloseAction();
    }

    
    function isFormValid() {
        var isValid = true;
        var messages = [];

        var currentValidation = {...validationObject};
     
        if(firstName === "" || firstName === undefined || firstName === null || !validationObject.firstNameError){
            isValid = false;
            messages.push(validationObject.firstNameError);
            currentValidation = {...currentValidation, hasFirstName:false }
        }

        if(lastName === "" || lastName === undefined || lastName === null || !validationObject.lastNameError){
            isValid = false;
            messages.push(validationObject.lastNameError);
            currentValidation = {...currentValidation, hasLastName:false }
        }

        if(dateOfBirth === undefined || dateOfBirth === null || !dateOfBirth.isValid || !validationObject.hasDob){
            isValid = false;
            messages.push(validationObject.dobError);
            currentValidation = {...currentValidation, hasDob:false }
        }

        if(maritalStatus === "" || maritalStatus === undefined || maritalStatus === null || !validationObject.hasMarital){
            isValid = false;
            messages.push(validationObject.maritalError);
            currentValidation = {...currentValidation, hasMarital:false }
        }

        if(dateOfBirth != null){
            var isDobValid = driverService.isValidDob(dateOfBirth.toDate());

            if(!isDobValid){
                isValid = false;
                messages.push(validationObject.invalidDobError);
                currentValidation = {...currentValidation, hasInvalidDob:false }
            }
        }
        
        // if(licenseNumber === "" || licenseNumber === undefined || licenseNumber === null || !validationObject.hasLicenseNumber){
        //     isValid = false;
        //     messages.push(validationObject.licenseNumberError);
        //     currentValidation = {...currentValidation, hasLicenseNumber:false }
        // }

        setValidation({...currentValidation })
        setErrors(messages);
        
        return isValid;
    }

    function onClose(e:any, driverNumber: number){
        onCloseAction();
    }

    function getDobErrorMessage(){
        if(!validationObject.hasDob){
            return validationObject.dobError;
        }

        if(!validationObject.hasInvalidDob){
            return validationObject.invalidDobError;    
        }

        return "";
    }
    return (
        <>
                                <div className={"container-edit-driver mb-5 " + (isVisible ? "expanded" : "")} data-index={containerKey}>
                                    <div className="pl-5 pt-6 pr-5 pb-6  border border-[#dee2e6]">
                                        <div className="grid gap-5 grid-cols-12">
                                            <div className="form-group col-span-12 sm:col-span-8 md:col-span-6 lg:col-span-4 xl:col-span-4">

                                                <TextField key="txtFirstName" 
                                                    data-index={driverNumber}
                                                    id="txtFirstName" 
                                                    name="FirstName"
                                                    className="p-1 w-full txtEditFirstName" 
                                                    label="First Name" 
                                                    variant="outlined" 
                                                    error={!validationObject.hasFirstName}
                                                    required={true}
                                                    onChange={(e)=>{
                                                        setFirstName(e.target.value)
                                                        setValidation({...validationObject, hasFirstName:(e.target.value !== "" ? true : false) })
                                                        addErrorMessage(e.target.value === "", validationObject.firstNameError, errors, setErrors);
                                                    }}
                                                    value={firstName}
                                                    helperText={!validationObject.hasFirstName ? validationObject.firstNameError : ""}
                                                    />
                                            </div>
                                            <div className="form-group col-span-12 sm:col-span-4 md:col-span-3 lg:col-span-2 xl:col-span-2">
                                                <TextField id="txtMiddleInitial" 
                                                    name="MiddleInitial" className="p-1"  
                                                    label="Middle Initial (optional)" 
                                                    variant="outlined" 
                                                    value={middleInitial}
                                                    onChange={(e)=>{ setMiddleInitial(e.target.value )}}
                                                    />
                                            </div>
                                            <div className="form-group col-span-12 sm:col-span-8 md:col-span-6 lg:col-span-4 xl:col-span-4">
                                            <TextField 
                                                id="txtLastName" 
                                                name="LastName" 
                                                className="p-1 w-full" 
                                                label="Last Name" 
                                                variant="outlined" 
                                                required={true}
                                                value={lastName}
                                                error={!validationObject.hasLastName}
                                                onChange={(e)=>{
                                                    setLastName(e.target.value)
                                                    setValidation({...validationObject, hasLastName:(e.target.value !== "" ? true : false) })
                                                    addErrorMessage(e.target.value === "", validationObject.lastNameError, errors, setErrors);
                                                }} 
                                                helperText={!validationObject.hasLastName ? validationObject.lastNameError : ""}
                                                />
                                            </div>
                                            <div className="form-group col-span-12 sm:col-span-4 md:col-span-3 lg:col-span-2 xl:col-span-2">
                                                <FormControl fullWidth>
                                                    <InputLabel id="lbl-ddlSuffix">Suffix (optional)</InputLabel>
                                                    <Select
                                                        labelId="lbl-ddlSuffix"
                                                        id="ddlSuffix"
                                                        label="Suffix (optional)"
                                                        value={suffix}
                                                        onChange={(e)=>{setSuffix(e.target.value)}}
                                                        data-drivernum={driverNumber}
                                                        >
                                                        <MenuItem value="JR">JR</MenuItem>
                                                        <MenuItem value="SR">SR</MenuItem>
                                                        <MenuItem value="I">I</MenuItem>
                                                        <MenuItem value="II">II</MenuItem>
                                                        <MenuItem value="III">III</MenuItem>
                                                        <MenuItem value="IV">IV</MenuItem>
                                                        <MenuItem value="V">V</MenuItem>
                                                        <MenuItem value="VI">VI</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div className=" col-span-12 pt-7 pb-7 text-[#cccccc]">
                                                <hr/>
                                            </div>
                                        </div>
                                        <div className=" grid grid-cols-12 sm:grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12">
                                            <div className="form-group col-span-12 sm:col-span-4 md:col-span-3 lg:col-span-2 xl:col-span-2">
                                                <TextField key="txtLicenseNumber" 
                                                        data-index={driverNumber}
                                                        id="txtLicenseNumber" 
                                                        name="LicenseNumber"
                                                        className="p-1 w-full txtEditFirstName" 
                                                        label="License Number" 
                                                        variant="outlined" 
                                                        //error={!validationObject.hasLicenseNumber}
                                                        //required={true}
                                                        value={licenseNumber}
                                                        onChange={(e)=>{
                                                            setLicenseNumber(e.target.value)
                                                            //setValidation({...validationObject, hasLicenseNumber:(e.target.value !== "" ? true : false) })
                                                            //addErrorMessage(e.target.value === "", validationObject.licenseNumberError, errors, setErrors);
                                                        }}
                                                        //helperText={!validationObject.hasLicenseNumber ? validationObject.licenseNumberError : ""}
                                                        />
                                            </div>
                                        </div>
                                        <div className="pt-5 grid grid-cols-12 sm:grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12">
                                            <div className="form-group col-span-12 sm:col-span-4 md:col-span-3 lg:col-span-2 xl:col-span-2">
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DateField 
                                                        label="Date Of Birth" 
                                                         value={dateOfBirth} 
                                                        className="w-full"
                                                        onChange={(e)=>{
                                                            setDateOfBirth(e);
                                                            setValidation({...validationObject, hasDob: e!== null && e!==undefined })
                                                            setValidation({...validationObject, hasInvalidDob: e!== null && driverService.isValidDob(e.toDate()) })
                                                            
                                                            addErrorMessage(!e?.isValid, validationObject.dobError, errors, setErrors);
                                                            addErrorMessage(!(e!== null && driverService.isValidDob(e.toDate())), validationObject.invalidDobError, errors, setErrors);
                                                        }}
                                                        slotProps={{
                                                            textField:{
                                                                error: !validationObject.hasDob || !validationObject.hasInvalidDob
                                                            }
                                                        }}
                                                    />
                                                    <FormHelperText className={"Mui-error"} >{getDobErrorMessage()}</FormHelperText>
                                                </LocalizationProvider>
                                            </div>
                                        </div>
                                        
                                        <div className="pt-5  grid grid-cols-12 sm:grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12">
                                            <div className="form-group col-span-12 sm:col-span-4 md:col-span-3 lg:col-span-2 xl:col-span-2">
                                                <FormControl fullWidth>
                                                    <InputLabel id="lbl-ddlMaritalStatus">Marital Status</InputLabel>
                                                    <Select
                                                        id="ddlMaritalStatus"
                                                        name="MaritalStatus"
                                                        label="Marital Status"
                                                        labelId="lbl-ddlMaritalStatus"
                                                        value={maritalStatus}
                                                        error={!validationObject.hasMarital}
                                                        onChange={(e)=>{
                                                            setMaritalStatus(e.target.value)
                                                            setValidation({...validationObject, hasMarital:(e.target.value !== "" ? true : false) });
                                                            addErrorMessage(e.target.value === "", validationObject.maritalError, errors, setErrors);
                                                            
                                                        }}
                                                        >
                                                        <MenuItem value="S">Single</MenuItem>
                                                        <MenuItem value="M">Married</MenuItem>
                                                    </Select>
                                                    <FormHelperText className={"Mui-error"} >{(!validationObject.hasMarital ? validationObject.maritalError : "")}</FormHelperText>
                                                </FormControl>
                                            </div>
                                        </div>

                                        <div className="pt-10 grid grid-cols-12 sm:grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12">
                                            <div className="form-group col-span-12">
                                                <span onClick={(e)=>{ onClose(e, driverNumber)}} className="w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/6 hover:cursor-pointer border border-[#b3b3b3] text-center float-left bg-[#f2f2f2] p-2 rounded-md active:bg-[#000000] active:text-[#fff] hover:bg-[#dfdfdf] float-left" >Cancel</span>
                                                <span className="w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/6 hover:cursor-pointer text-center float-right bg-[#0071eb] text-[#ffffff] p-2 rounded-md active:bg-[#0a58ca] float-right" onClick={(e)=>{ onSave(e) }}>{action=="NEW" ? "Save": "Update"}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* </form> */}
        </>
    );
}

export default EditDriverForm;